<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import * as echarts from 'echarts';
import resize from './mixins/resize'

export default {
  name: 'LineChart',
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '400px'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart: []
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')
      this.setOptions(this.chartData)
    },
    setOptions({ expectedData, actualData, yAxis1, yAxis2, xAxisdata } = {}) {
      this.chart.setOption({
        backgroundColor: '#fff',
        xAxis: {
          data: xAxisdata,
          boundaryGap: false,
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#afafaf'
            }
          }
        },
        grid: {
          left: 10,
          right: 40,
          bottom: 50,
          top: 30,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          padding: [5, 10]
        },
        yAxis: [
          {
            type: 'value',
            name: yAxis2,
            // min: 0,
            // max: 180,
            axisTick: {
              show: false
            },
            axisLine: { show: false },
            splitLine: {
              lineStyle: {
                color: '#f4f4f4',
                type: 'dash',
                width: 2
              }
            }
          },
          {
            type: 'value',
            name: yAxis1,
            // min: 0,
            // max: 70000000,
            axisTick: {
              show: false
            },
            axisLine: { show: false },
            splitLine: { show: false },
            nameLocation: 'end',
            alignTicks: true
            // inverse: true // 是否是反向坐标轴
          }
        ],
        // legend: {
        //   data: ['expected', 'actual']
        // },
        dataZoom: [
          {
            show: true,
            realtime: true,
            // start: 65,
            // end: 85
          },
          {
            type: 'inside',
            realtime: true,
            // start: 65,
            // end: 85
          }
        ],
        series: [{
          name: yAxis2,
          itemStyle: {
            normal: {
              color: '#FF005A',
              lineStyle: {
                color: '#FF005A',
                width: 1.5
              }
            }
          },
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#ffebf3'
              }, {
                offset: 0.8,
                color: 'rgba(255,255,255,0.1)'
              }], false)
            }
          },
          smooth: true,
          symbol: 'circle',
          symbolSize: 5,
          showSymbol: false,
          type: 'line',
          data: expectedData,
          animationDuration: 2800,
          animationEasing: 'cubicInOut',
          yAxisIndex: 0
        },
        {
          name: yAxis1,
          smooth: true,
          type: 'line',
          symbol: 'circle',
          symbolSize: 5,
          showSymbol: false,
          itemStyle: {
            normal: {
              color: '#3888fa',
              lineStyle: {
                color: '#3888fa',
                width: 1.5
              }
              // areaStyle: {
              //   color: '#f3f8ff'
              // }
            }
          },
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#e5eeff'
              }, {
                offset: 0.8,
                color: 'rgba(255,255,255,0.1)'
              }], false)
            }
          },
          data: actualData,
          animationDuration: 2800,
          animationEasing: 'quadraticOut',
          yAxisIndex: 1
        }]
      })
    }
  }
}
</script>
